import Api from './Api'

export default {
  loadExpertsJson (from, till, avdelingsid = null, brukernavn = null) {
    return Api().get('/statistikk/ekspert.json', {
      params: {
        from: from,
        till: till,
        avdelingsid: avdelingsid,
        brukernavn: brukernavn
      }
    })
  },

  loadCategoriesJson (params) {
    return Api().get('/statistikk/kategori.json', {
      params: params
    })
  },

  loadFullobjektJson (params) {
    return Api().get('/statistikk/full-objekt.json', {
      params: params
    })
  },

  loadAuksjonsstatistikk (params) {
    return Api().post('/statistikk/auksjonsstatistikk.json', {
      'auksjon': params.code,
      'category': params.category,
      'from': params.date.from,
      'to': params.date.till
    })
  },

  loadProsentandelSalgsdagenJson (from = null, till = null, category = null) {
    return Api().get('/statistikk/prosentandel-salgsdagen.json', {
      params: {
        from: from,
        till: till,
        category: category
      }
    })
  },

  loadVinpakkelisteJson (params) {
    return Api().get('/statistikk/vinpakkeliste.json', {
      params: params
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/StatistikkService.js